import { jsx as _jsx } from "react/jsx-runtime";
import styles from '../../DealerLocator.module.scss';
import cx from 'classnames';
export const DealerLocatorSearchResultAddress = ({ children, isStoreLocationMapViewUpdateFlag = false }) => (_jsx("p", { className: cx(styles['dealer-locator-text'], 'cat-u-theme-typography-body my-0', {
        'cat-u-theme-typography-body-sm': isStoreLocationMapViewUpdateFlag,
        'cat-u-theme-typography-body': !isStoreLocationMapViewUpdateFlag
    }), children: children }));
